<!-- 
  Projeto: eleicoes2020
  Arquivo: CheckMobile.vue
  ---------------------------------------------------------------------
  Autor: Leonardo Nascimento
  E-mail: oi@bewweb.com.br
  ---------------------------------------------------------------------
  Data da criação: 13/11/2020 9:40:07 pm
  Last Modified:  14/11/2020 1:02:43 am
  Modificado por: Leonardo Nascimento - <oi@bewweb.com.br>
  ---------------------------------------------------------------------
  Copyright (c) 2020 Bewweb
  HISTORY:
  Date      	By	Comments
  ----------	---	---------------------------------------------------------
  -->

<template>
  <div></div>
</template>
<script>
export default {
    name: 'CheckMobile',
    data() {
    	return {
    		check: false,
    	}
    },
    methods: {
      mobileCheck(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          let file = document.createElement('link');
          file.rel = 'stylesheet';
          file.href = this.baseUrl + '/static/template/css/mobile.css?v=2'
          document.head.appendChild(file);
        }else{
         let file = document.createElement('link');
          file.rel = 'stylesheet';
          file.href = this.baseUrl +'/static/template/css/style.css?v=2'
          document.head.appendChild(file);
        }
      if(process.env.NODE_ENV == "production")
        console.log("%cCGN - CENTRAL GAZETA DE NOTÍCIAS","font-family: 'Times New Roman', Arial, serif; font-weight: bold; color: #289DFD; font-size: 45px;"),console.log("%cSistema desenvolvido por: ","font-family: Arial, serif;color: #000; font-size: 15px;"),console.log("%cLeonardo Nascimento, Giuliano Saito","font-family: Arial, serif; color: black; font-size: 18px; font-weight: bold;"),console.log("%cleonardo.nascimento21@gmail.com, giulianosaito@gmail.com","font-family: Arial, serif; color: black; font-size: 18px; font-weight: bold;"),console.log=function(){},console.info=function(){},console.warn=function(){};
      }

   	},
    created() {
      this.mobileCheck();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CheckMobile.vue